import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import INITIAL_FORMDATA from "./_initialFormData";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError] = useState(null);
  const { pollingInterval } = formData;
  const availableLog = [
    { label: t("googleworkspace.log_types.admin"), value: "ADMIN_ACTIVITY_LOGS" },
    { label: t("googleworkspace.log_types.drive"), value: "DRIVE_ACTIVITY_LOGS" },
    { label: t("googleworkspace.log_types.authorization_token"), value: "AUTHORIZATION_TOKEN_LOGS" },
    { label: t("googleworkspace.log_types.message_tracking"), value: "MESSAGE_TRACKING_LOGS" },
    { label: t("googleworkspace.log_types.calendar"), value: "CALENDAR_ACTIVITY_LOGS" },
    { label: t("googleworkspace.log_types.login"), value: "LOGIN_ACTIVITY_LOGS" }
  ];
  const [logTypes, setLogTypes] = useState(INITIAL_FORMDATA.availableLogs.value);
  const [logTypeVal, setLogTypeVal] = useState(false);
  const handleSubmit = () => {
    if (logTypes.length === 0) {
      setLogTypeVal(true);
      return;
    }
    formData.logs.value = logTypes;
    onSubmit();
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "logs" }, t("googleworkspace.subscribe.log_types_label")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        multi: true,
        name: "logs",
        id: "logs",
        onChange: (selected) => {
          setLogTypes(selected);
        },
        options: availableLog,
        value: logTypes
      }
    ),
    logTypeVal && logTypes.length === 0 && /* @__PURE__ */ React.createElement("label", null, t("googleworkspace.subscribe.select_at_least_one")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("googleworkspace.subscribe.log_types_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue,
        min: "1",
        max: "60",
        onChange,
        required: true,
        help: t("googleworkspace.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
